/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Stores/ServiceEndpointRequestHistoryStore" />
import { ServiceEndpointExecutionRecord } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { ServiceEndpointsSource } from "DistributedTaskUI/ServiceEndpoints/Details/Source/ServiceEndpointsSource";
import { StoreBase } from "DistributedTask/Flux/Store";
import { IVssPageContext } from "VSS/Platform/Context";
import { PagedList } from "VSS/Platform/Contracts/WebApi";

export interface IServiceEndpointRequestHistoryStoreProps {
    endpointId: string;
    pageContext: IVssPageContext;
}

export class ServiceEndpointRequestHistoryStore extends StoreBase {

    public static readonly LoadingStarted = "loadingStarted";
    public static readonly LoadingFinished = "loadingFinished";
    public static readonly DefaultTopRecords = 15;

    private _isLoading: boolean;
    private _continuationToken: number;

    private readonly _endpointId: string;
    private readonly _source: ServiceEndpointsSource;
    private readonly _records: ServiceEndpointExecutionRecord[];

    constructor(props: IServiceEndpointRequestHistoryStoreProps) {
        super("");

        this._endpointId = props.endpointId;
        this._source = ServiceEndpointsSource.getInstance(props.pageContext);
        this._records = [];
        this._isLoading = false;
        this._continuationToken = undefined;
    }

    public static getKey(): string {
        return "service-endpoints-request-history-store";
    }

    public disposeInternal(): void {
    }

    public reset(): void {
        this._records.splice(0, this._records.length);
        this._continuationToken = undefined;
    }

    public fetchData(top?: number): void {
        if (this._isLoading) {
            return;
        }

        if (this._continuationToken === 0) {
            return; //no more data from server
        }

        this._isLoading = true;
        this.emit(ServiceEndpointRequestHistoryStore.LoadingStarted, this);
        this._source.getServiceEndpointExecutionRecords(this._endpointId, top || ServiceEndpointRequestHistoryStore.DefaultTopRecords, this._continuationToken).then(this._onDataAvailable);
    }

    public getExecutionRecords(): ServiceEndpointExecutionRecord[] {
        return this._records;
    }

    // Delete this method once EnableStreamlinedScrollEventsInServiceEndpointHistory FF is removed
    public hasMore(): boolean {
        if (this._isLoading) {
            return false;
        }

        if (this._continuationToken === undefined) {
            return true;
        }

        return this._continuationToken > 0;
    }

    private _onDataAvailable = (response: PagedList<ServiceEndpointExecutionRecord>): void => {
        this._isLoading = false;
        this._continuationToken = Number(response.continuationToken) || 0;
        const records = response as ServiceEndpointExecutionRecord[];
        this._records.push(...records);
        this.emit(ServiceEndpointRequestHistoryStore.LoadingFinished, this);
    }
}
